import type { ProductImageEntry } from "./types";

const entry = (
  preset: string,
  module: string,
  altSv: string,
  altEn: string,
  showsSv: string,
  showsEn: string,
  provesSv: string,
  provesEn: string,
): ProductImageEntry => ({
  id: `analytics.explore.${preset.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`,
  module,
  area: "solution",
  opens: `Schema → Analys → Utforska → ${module}`,
  setup: ["Öppna ett sparat DEV-resultat i Analys", `Välj preset ${module}`],
  scenario: "S1",
  visual: { variant: 0 },
  text: {
    sv: { alt: altSv, shows: showsSv, proves: provesSv },
    en: { alt: altEn, shows: showsEn, proves: provesEn },
  },
  use: ["pages/Plattform.tsx"],
});

export const ANALYTICS_DETAIL_CATALOGUE: readonly ProductImageEntry[] = [
  entry(
    "unassigned",
    "Otilldelade",
    "Analys av otilldelade besök med orsaksfördelning och besökslista",
    "Analysis of unassigned visits with cause breakdown and visit list",
    "Se orsaksfördelningen och vilka besök som saknar tilldelning.",
    "See the cause breakdown and which visits remain unassigned.",
    "Analysvyn visar orsaker och otilldelade besök för den valda lösningen.",
    "The analysis view shows causes and unassigned visits for the selected solution.",
  ),
  entry(
    "supplyDemand",
    "Utbud vs efterfrågan",
    "Diagram över efterfrågan och bemanning över tid",
    "Chart of demand and staffing over time",
    "Diagrammet visar efterfrågan och bemanning under perioden.",
    "The chart shows demand and staffing across the period.",
    "Diagrammet visar lösningens fördelning av efterfrågan och utbud över tid.",
    "The chart shows the solution's distribution of demand and supply over time.",
  ),
  entry(
    "bottlenecks",
    "Flaskhalsar",
    "Värmekarta över efterfrågan och täckning per dag och timme",
    "Heatmap of demand and coverage by day and hour",
    "Värmekartan visar timfördelningen för efterfrågan och täckning.",
    "The heatmap shows the hourly distribution of demand and coverage.",
    "Värmekartan visar lösningens timfördelning per dag.",
    "The heatmap shows the solution's hourly distribution by day.",
  ),
  entry(
    "perEmployee",
    "Per medarbetare",
    "Stapeldiagram över ledig tid per medarbetare",
    "Bar chart of idle time by employee",
    "Jämför måttet ledig tid mellan medarbetare.",
    "Compare the idle-time measure across employees.",
    "Stapeldiagrammet visar det valda lösningsmåttet per medarbetare.",
    "The bar chart shows the selected solution measure for each employee.",
  ),
  entry(
    "perClient",
    "Per brukare",
    "Stapeldiagram över otilldelad tid per brukare",
    "Bar chart of unassigned time by client",
    "Jämför otilldelad tid mellan brukare.",
    "Compare unassigned time across clients.",
    "Stapeldiagrammet visar det valda lösningsmåttet per brukare.",
    "The bar chart shows the selected solution measure for each client.",
  ),
  entry(
    "perDistrict",
    "Per distrikt",
    "Stapeldiagram över otilldelad tid per distrikt",
    "Bar chart of unassigned time by district",
    "Jämför otilldelad tid mellan distrikt.",
    "Compare unassigned time across districts.",
    "Utforska visar lösningens valda mått per distrikt.",
    "Explore shows the selected solution measure for each district.",
  ),
  entry(
    "transport",
    "Transport",
    "Stapeldiagram över restid per transportsätt",
    "Bar chart of travel time by transport mode",
    "Jämför lösningens restid per transportsätt.",
    "Compare the solution's travel time by transport mode.",
    "Utforska visar restid för de transportsätt som ingår i lösningen.",
    "Explore shows travel time for the transport modes present in the solution.",
  ),
  entry(
    "shift",
    "Per skift",
    "Stapeldiagram över ledig tid per skift",
    "Bar chart of idle time by shift",
    "Jämför måttet ledig tid mellan skift.",
    "Compare the idle-time measure across shifts.",
    "Stapeldiagrammet visar det valda lösningsmåttet per skift.",
    "The bar chart shows the selected solution measure for each shift.",
  ),
  entry(
    "continuity",
    "Kontinuitet per brukare",
    "Stapeldiagram över kontinuitet per brukare",
    "Bar chart of continuity by client",
    "Se hur kontinuitetsmåttet fördelas mellan brukare.",
    "See how the continuity measure varies across clients.",
    "Stapeldiagrammet visar lösningens kontinuitetsmått per brukare.",
    "The bar chart shows the solution's continuity measure for each client.",
  ),
];
